import React, { useState, useRef } from "react";
import { useGlobalContext } from "../../../../Context/GlobalContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthContext } from "../../../../Context/AuthContext";
import flowChangerLogo from "../../../../Assets/Images/flowchangerAINew.jpeg";
import loginSlash from "../../../../Assets/Images/login-slash.jpeg";
import loginLady from "../../../../Assets/Images/login-lady.png";


const Step3 = () => {
  const navigate = useNavigate();
  const { baseUrl, openToast } = useGlobalContext();
  const { nextStep, adminInfo, updatedAdminInfo, profile } = useAuthContext();
  console.log(profile)
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const email = searchParams.get("email");
  console.log(email)
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);


  const handleCodeChange = (index, value) => {
    const newCode = [...code];
    newCode[index] = value.slice(-1); // Only take the last character
    setCode(newCode);

    if (value && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handlePaste = (event) => {
    const pastedData = event.clipboardData.getData("Text").slice(0, 6); // Get the first 6 characters
    const newCode = pastedData.split("");
    setCode([...newCode, ...Array(6 - newCode.length).fill("")]);

    const lastField = inputRefs.current[Math.min(newCode.length, 5)];
    if (lastField) lastField.focus();
  };

  const submitOtp = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(baseUrl + "admin/verify-otp", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ otp: code.join(""), email: email.length > 0 ? email : profile?.email }),
      });

      if (response.status === 200) {
        setIsLoading(false);
        openToast("OTP verified successfully!", "success");
        nextStep();
        setSearchParams({ step: 4, email: email.length > 0 ? email : profile?.email });
      } else {
        const result = await response.json();
        openToast(result.message || "OTP verification failed.", "error");
      }
    } catch (error) {
      openToast("An error occurred. Please try again.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const ResendOTP = async () => {
    try {
      const response = await fetch(baseUrl + "admin", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...updatedAdminInfo, email: email.length > 0 ? email : profile?.email }),
      });

      if (response.status === 201) {
        openToast("OTP sent successfully!", "success");
      } else {
        const result = await response.json();
        openToast(result.message || "Failed to resend OTP.", "error");
      }
    } catch (error) {
      openToast("Error while resending OTP: " + error.message, "error");
    }
  };

  return (
    <div className="flex justify-center items-center px-[10px] md:px-[20px] lg:px-[20px] xl:px-[20px] py-[10px] md:py-[20px] lg:py-[20px] xl:py-[20px] h-lvh min-h-screen overflow-y-auto">
      <div className="flex justify-center items-center gap-x-3 bg-white rounded-lg w-[100%] xl:w-[80%] login-div">

        <div className="py-[20px] w-[100%] md:w-1/2 xl:w-[50%] h-full">
          <div className="flex justify-center items-center my-3">
            <img src={flowChangerLogo} className="w-[120px]" />
          </div>
          <h2 className="mb-4 font-normal text-black text-2xl text-center">
            Verify your Email
          </h2>
          <p className="mb-2 text-gray-600 text-center">
            We sent a confirmation code on
          </p>
          <p className="mb-6 font-semibold text-center">{adminInfo.email}</p>
          <div className="flex justify-center space-x-2 mb-6" onPaste={handlePaste}>
            {code.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputRefs.current[index] = el)}
                type="text"
                maxLength="1"
                className="border-2 border-gray-300 focus:border-[#8a25b0] rounded-md focus:outline-none w-10 xl:w-[12] h-[10] xl:h-12 text-2xl text-center"
                value={digit}
                onChange={(e) => handleCodeChange(index, e.target.value)}
              />
            ))}
          </div>
          <div className="text-center">
            <button
              onClick={submitOtp}
              disabled={isLoading}
              className={` font-medium  py-[8px] px-4 rounded-full transition duration-300  mb-4 w-[290px] ${isLoading ? "bg-gray-400 cursor-not-allowed" : "bg-[#8a25b0] text-white hover:bg-[#884a9f] verify-button"
                }`}
            >
              Verify
            </button>
          </div>
          <p className="text-sm text-center">
            Didn't receive a code?{" "}
            <a href="#" className="text-[#8a25b0] hover:text-[#884a9f]" onClick={ResendOTP}>
              Send it again
            </a>
          </p>
        </div>


        <div className="hidden login-right relative md:flex justify-center items-center bg-[#9181F4] px-[30px] py-[10px] w-[50%] md:w-1/2 lg:w-[50%] xl:w-[50%] h-[450px] text-4xl text-center">
          <div className="relative bg-[#e2e0e938] border border-[#bfbfbf66] rounded-xl w-[80%] h-[83%]">
            <h2 className="p-[18px] w-[212px] font-bold text-[32px] text-white md:text-[22px] text-left">
              Verify your OTP to secure your account.
            </h2>
            <div className="top-[6px] right-[-53px] bottom-0 absolute">
              <img src={loginLady} alt="loginLady" className='h-[350px]' />
            </div>
            <div className="left-[-20px] absolute bg-white p-[10px] rounded-full">
              <img
                src={loginSlash}
                alt="loginSlash"
                className="rounded-full"
              />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Step3;
